// extracted by mini-css-extract-plugin
export default {"content":"_3iMn_a","contentWrapper":"p7XHqy"};